import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=63cc5522&scoped=true&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc5522",
  null
  
)

export default component.exports